export enum MixedPanelState {
    STATE_DESTROYED,
    STATE_BEFORE_SHOWING
}
